export default {
  title: {
    id: 'product_prepaid_plan_modal_title',
    defaultMessage: 'Prepaid plan • What’s included?',
  },
  section1Title: {
    id: 'product_prepaid_plan_section_1_title',
    defaultMessage: '25 GB Data Bundle by US Mobile',
  },
  section1Paragraph1: {
    id: 'product_prepaid_plan_section_1_paragraph_1',
    defaultMessage:
      'Being chronically online has never been easier. You’ll get unlimited talk, text, and 25GB of Warp 5G data on the nation’s fastest networks. No contract required.',
  },
  section1Paragraph2: {
    id: 'product_prepaid_plan_section_1_paragraph_2',
    defaultMessage:
      'Plus — free hotspot access, exclusive for Back Market customers.',
  },
  sectionPriceTitle: {
    id: 'product_prepaid_plan_section_price_title',
    defaultMessage: '$30.00 per month',
  },
  sectionPriceDescription: {
    id: 'product_prepaid_plan_section_price_description',
    defaultMessage: 'Service fee and recovery fee included',
  },
  section2Title: {
    id: 'product_prepaid_plan_section_2_title',
    defaultMessage: 'The bundle includes',
  },
  section2Item1: {
    id: 'product_prepaid_plan_section_2_item_1',
    defaultMessage: '25 GB of Warp 5G premium data',
  },
  section2Item2: {
    id: 'product_prepaid_plan_section_2_item_2',
    defaultMessage: 'Hotspot data access',
  },
  section2Item3: {
    id: 'product_prepaid_plan_section_2_item_3',
    defaultMessage: 'Unlimited talk and text',
  },
  section2Item4: {
    id: 'product_prepaid_plan_section_2_item_4',
    defaultMessage: 'WiFi calling',
  },
  section2Item5: {
    id: 'product_prepaid_plan_section_2_item_5',
    defaultMessage: '24/7 customer support',
  },
  section2Item6: {
    id: 'product_prepaid_plan_section_2_item_6',
    defaultMessage: 'Activation Kit included',
  },
  section3Title: {
    id: 'product_prepaid_plan_section_3_title',
    defaultMessage: 'How to get started',
  },
  section3Block1Step: {
    id: 'product_prepaid_plan_section_3_block_1_step',
    defaultMessage: 'Step 1',
  },
  section3Block1Title: {
    id: 'product_prepaid_plan_section_3_block_1_title',
    defaultMessage: 'Get an Activation Kit',
  },
  section3Block1Description: {
    id: 'product_prepaid_plan_section_3_block_1_description',
    defaultMessage:
      'You’ll need to create an account with US Mobile or {link, html}. From there you can order a Starter Kit — it’ll come with a SIM ejector and a SIM on each network to get you activated.',
  },
  section3Block1DescriptionLink: {
    id: 'product_prepaid_plan_section_3_block_1_description_link',
    defaultMessage: 'log in if you already have one',
  },
  section3Block2Step: {
    id: 'product_prepaid_plan_section_3_block_2_step',
    defaultMessage: 'Step 2',
  },
  section3Block2Title: {
    id: 'product_prepaid_plan_section_3_block_2_title',
    defaultMessage: 'Activate your line',
  },
  section3Block2Description: {
    id: 'product_prepaid_plan_section_3_block_2_description',
    defaultMessage:
      'Get all your bundle has to offer by adding your new line. {link, html} to help you find it.',
  },
  section3Block2DescriptionLink: {
    id: 'product_prepaid_plan_section_3_block_2_description_link',
    defaultMessage: 'Here are instructions',
  },
  section4Title: {
    id: 'product_prepaid_plan_section_4_title',
    defaultMessage: 'What is US Mobile?',
  },
  section4Paragraph1: {
    id: 'product_prepaid_plan_section_4_paragraph_1',
    defaultMessage:
      'US Mobile is the next-gen wireless carrier built for the 21st century and the age of 5G with the best-in-class user experience, features, and phone plans. With the Warp 5G network’s ultra-fast speed and reliability, you’ll stay connected to everything you need on the go.',
  },
  section4Paragraph2: {
    id: 'product_prepaid_plan_section_4_paragraph_2',
    defaultMessage:
      'Yup, that means no more excuses for missing calls from grandma.',
  },
  section5Title: {
    id: 'product_prepaid_plan_section_5_title',
    defaultMessage: '24/7 Customer Service',
  },
  section5Paragraph: {
    id: 'product_prepaid_plan_section_5_paragraph',
    defaultMessage:
      'If you run into any issues, customer service is available 24/7 over phone, email or chat. You’ll get fast responses from real people.',
  },
  section5Button: {
    id: 'product_prepaid_plan_section_5_button',
    defaultMessage: 'Talk to US Mobile',
  },
}
